module.exports = __webpack_public_path__ + "img/Mary-Lyndon-Hall-t-26690-002.cdd1ee5f.jpg";